module.exports = __webpack_public_path__ + "static/media/daphne-icon.f94bd8dd.png";